import { createFileRoute } from '@tanstack/react-router'

import { TenantLayout } from '@/pages/tenants/detail/TenantLayout'

export const Route = createFileRoute('/_authenticated/tenants/$id')({
  component: TenantLayout,
})
